module.exports = __webpack_public_path__ + "img/system-rank-avatar.f3d7ef98.png";